import { isArray, camelCase, upperFirst } from 'lodash'

function objectCaseFactory(caseFunction){ 
  var objectFunction = (o) =>{ 
    return (typeof o !== 'object' || o === null) ? o :
      (isArray(o)) ? o.map(objectFunction) :
        Object.keys(o).reduce((prev, current) => {
          const ccKey = caseFunction(current);
          if (Array.isArray(o[current])) {
            prev[ccKey] = o[current].map(el => objectFunction(el));
          } else if (typeof o[current] === 'object') {
            prev[ccKey] = objectFunction(o[current]);
          } else {
            prev[ccKey] = o[current];
          }
          return prev;
        }, {});
  }
  return objectFunction;
}

export function objectKeysToCamelCase(o) {
  return objectCaseFactory(camelCase)(o);
}
export function objectKeysToPascalCase(o) {
  return objectCaseFactory(upperFirst)(
          objectCaseFactory(camelCase)(o)
        );
}